import React from 'react';
import { ShoppingBag, Tag, Box } from 'lucide-react';
import { motion } from 'framer-motion';

const STORE_CATEGORIES = [
  {
    id: 'bonus',
    title: 'Bonus Kodlari',
    desc: 'Ozel indirim ve bonus kodlari ile kazancinizi artirin.',
    icon: Tag
  },
  {
    id: 'merch',
    title: 'BetMax Merch',
    desc: 'BetMax markalii ozel urunler ve aksesuarlar.',
    icon: ShoppingBag
  },
  {
    id: 'digital',
    title: 'Dijital Urunler',
    desc: 'Dijital hediye kartlari ve ozel iceriklere ulasin.',
    icon: Box
  }
];

const Store = () => {
  return (
    <div style={{ padding: '3rem 0' }}>
      <div className="page-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title" style={{ fontSize: '2rem' }} data-testid="store-page-title">Store</h1>
          <p className="section-subtitle">BetMax magazasi - Ozel teklifler ve urunler</p>
        </motion.div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '1.25rem'
        }}>
          {STORE_CATEGORIES.map((cat, idx) => {
            const Icon = cat.icon;
            return (
              <motion.div
                key={cat.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="sponsor-card" style={{ padding: '2rem', textAlign: 'center' }}>
                  <div style={{
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    background: 'rgba(0,194,255,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.25rem',
                    border: '1px solid rgba(0,194,255,0.15)'
                  }}>
                    <Icon size={28} style={{ color: 'hsl(200, 96%, 60%)' }} />
                  </div>
                  <h3 className="sponsor-card-name" style={{ marginBottom: '0.5rem' }}>{cat.title}</h3>
                  <p className="sponsor-card-desc" style={{ marginBottom: '1.25rem' }}>{cat.desc}</p>
                  <span className="sponsor-card-badge" style={{ background: 'rgba(249,248,113,0.12)', color: 'hsl(59, 94%, 71%)', borderColor: 'rgba(249,248,113,0.25)' }}>Yakinda</span>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Store;
